module.exports = __webpack_public_path__ + "media/images/payouts-f3ec3f1b880687dea74827082072bc60.png";